import { render } from "./mobileAppComponent.vue?vue&type=template&id=227e7f53"
import script from "./mobileAppComponent.vue?vue&type=script&lang=js"
export * from "./mobileAppComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__